<template>
  <div class="one-column-view">
    <div class="article-content">
      <img src="../assets/beta.png" alt="Join Beta" />
      <h1>Join Goldenlink+ Beta Program</h1>
      <p>
        Participate in our community QA activities, you will be rewarded with
        GCoins and tokens in the following ways:
      </p>
      <ol>
        <li>Register to join on the GoldenLink+ app.</li>
        <li><strong>Join the “Bug Tracking Community”</strong></li>
        <li>
          Start your community activities, pay special attention to the user
          experience when you use the app, once you find any bad experience,
          including any bugs, don't wait, the first screenshot is posted to our
          Bug Tracking community, and the text points out where the problem is,
          and your advice and feelings.
        </li>
        <li>
          Regarding rewards: We will review these posts one by one. Note: If you
          are the first to find a problem, if the system recognizes your
          discovery, you will be the only winner of the discovery.
        </li>
        <li>
          Bonus: If we approve your bug report as correct. Your rewards will be
          200 GCoins per reported bug. There is no limit. After 60 days of
          staking, your reward will be doubled. If you apply to be a GOLD miner,
          then you will be rewarded another 400 GCoins after 60 days.
        </li>
        <li>
          There are two income rewards, the GCoins and tokens. After Proof of
          Staking (POS), you can then cash out your GCoins. Tokens will remain
          locked up waiting for system completion.
        </li>
      </ol>
      <div class="w-100 w-md-50">
          <DownloadApp />
      </div>
    </div>
  </div>
</template>

<script>
import DownloadApp from "@/components/DownloadApp.vue";

export default {
  components: {
    DownloadApp,
  },
};
</script>

<style scoped></style>
